import OrderBookRequest from './OrderBookRequest';
import OrderRequest from './OrderRequest';
import OrderTransactionRequest from './OrderTransactionRequest';
import PriceRequest from './PriceRequest';
import UserRequest from './UserRequest';
import SettingRequest from './SettingRequest';
import LoginRequest from './LoginRequest';
import TransactionRequest from './TransactionRequest';
import WhiteListRequest from './WhiteListRequest';
import NotifyRequest from './NotifyRequest';
import CommissionRequest from './CommissionRequest';
import CampaignRequest from './CampaignRequest';
import FavoritesRequest from './FavoritesRequest';
import NotificationRequest from './NotificationRequest';

const requestMap = {
  OrderBookRequest,
  OrderRequest,
  OrderTransactionRequest,
  PriceRequest,
  UserRequest,
  SettingRequest,
  LoginRequest,
  TransactionRequest,
  WhiteListRequest,
  NotifyRequest,
  CommissionRequest,
  CampaignRequest,
  FavoritesRequest,
  NotificationRequest,
};

const instances = {};

export default class RequestFactory {
  static getRequest(classname) {
    const RequestClass = requestMap[classname];
    if (!RequestClass) {
      throw new Error(`Invalid request class name: ${classname}`);
    }

    let requestInstance = instances[classname];
    if (!requestInstance) {
      requestInstance = new RequestClass();
      instances[classname] = requestInstance;
    }
    return requestInstance;
  }
}
